import "../styles/Homepage.css";
import heroPortrait from "../assets/img/picture-1.png";
import aboutPhoto from "../assets/img/picture-3.png";

export default function Homepage() {
    return (
        <>
            <main className="home-hero" id="home">
                <div className="home-container">
                    <h1 className="home-title">
                        Dott. Giammarco <span className="last-name">Lamanda</span>
                    </h1>

                    <div className="home-portrait-wrap" aria-hidden="true">
                        <img
                            src={heroPortrait}
                            alt="Giammarco Lamanda"
                            className="home-portrait"
                            loading="eager"
                        />
                    </div>

                    <p className="home-sub">
                        Alimenta la tua performance, migliora il tuo recupero, supera i tuoi limiti.<br/>
                        Con la giusta strategia nutrizionale puoi trasformare ogni allenamento in un passo verso il tuo
                        obiettivo.
                    </p>

                    <div className="home-ctas">
                        <a href="/services" className="btn btn-outline">Cosa faccio</a>
                        <a href="/about-me" className="btn btn-solid">Chi sono</a>
                    </div>
                </div>
            </main>

            <section className="about" id="chi-sono">
                <div className="about-container">
                    <div className="about-media">
                        <img
                            src={aboutPhoto}
                            alt="Giammarco Lamanda"
                            className="about-photo"
                            loading="lazy"
                        />
                    </div>

                    <div className="about-text">
                        <h2 className="about-title">
                            Ciao, sono <span className="about-name">Giammarco</span>
                        </h2>

                        <p>
                            Sono un biologo nutrizionista e chinesiologo, specializzato in nutrizione sportiva e
                            funzionale. Da anni aiuto atleti e appassionati di sport a trovare la giusta strategia per
                            dare il massimo, in allenamento e in gara.

                        </p>

                        <p>
                            Che tu corra lunghe distanze, pratichi sport di resistenza o cerchi la massima esplosività
                            negli sport di potenza, il mio obiettivo è uno: portarti al livello successivo.

                        </p>

                        <p>
                            Il percorso non si ferma alla dieta: insieme lavoriamo anche su sonno, recupero ed
                            equilibrio psicofisico, perché la vera performance nasce da un corpo nutrito e una mente
                            rigenerata.

                        </p>

                        <p>
                            Non lasciare i tuoi risultati al caso: costruiscili, passo dopo passo.
                        </p>

                        <a href="/about-me" className="btn btn-ghost about-cta">
                            Scopri di più <span className="arrow">→</span>
                        </a>
                    </div>
                </div>
            </section>
            <script src="https://elfsightcdn.com/platform.js" async></script>
            <div className="elfsight-app-79cc004f-fbba-43b6-8db5-affac0fd8a19" data-elfsight-app-lazy></div>
        </>
    );
}